import React from "react";
import { Formik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Import web-specific components
import { WesoTextInput } from "../components/web/WesoTextInput";
import { GradientText } from "../components/web/GradientText";
import { GradientButton } from "../components/web/GradientButton";

// Import web-specific Firebase auth services
import {
  loginWithEmailAndPassword,
} from "../services/firebase/auth";

interface LoginFormValues {
  email: string;
  password: string;
}

export const LoginForm: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onLoginHandler = async (values: LoginFormValues) => {
    const { email, password } = values;
    try {
      await loginWithEmailAndPassword(email, password);
      navigate("/home");
    } catch (error: any) {
      const errorMessage = error.message;
      window.alert(t("login.error", { errorMessage }));
    }
  };

  return (
    <Formik<LoginFormValues>
      initialValues={{ email: "", password: "" }}
      onSubmit={onLoginHandler}
    >
      {({ handleChange, handleSubmit, values }) => (
        <div className="login-form">
          <GradientText
            text={t("login.title")}
            textAlign={"left"}
            size={30}
            widthAuto={false}
          />
          <WesoTextInput
            name={"email"}
            label={t("login.emailLabel")}
            placeholder={t("login.emailPlaceholder")}
            onChangeText={handleChange("email")}
            value={values.email}
            className="mb-s"
          />
          <WesoTextInput
            name={"password"}
            label={t("login.passwordLabel")}
            placeholder={"*********"}
            secureTextEntry
            className="mb-s"
            onChangeText={handleChange("password")}
            value={values.password}
          />
          <Link to="/reset-password" className="text-link mb-s text-right">
            {t("login.forgotPassword")}
          </Link>
          <div className="mb-xs">
            <GradientButton label={t("login.loginButton")} onPress={() => handleSubmit()} />
          </div>
        </div>
      )}
    </Formik>
  );
};
